import { Filter } from 'schemas/FilterSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { DashboardWidgetType } from 'features/dashboard/types'
import { SearchFilterComposingStrategy } from '../searchFilterComposingStrategy'
import { DecoratedSearchFilterComposingStrategy } from './type'

const pivotTagDecorator = (
  strategy: SearchFilterComposingStrategy
): DecoratedSearchFilterComposingStrategy => ({
  composeDetailSearchFilter: (
    filter: Filter,
    insights: InsightData[],
    pivots: InsightData[],
    widgetSetting?: DashboardWidgetType
  ) => {
    const alteredFilter =
      insights.length > 0
        ? strategy.composeDetailSearchFilter(filter, insights, widgetSetting)
        : filter

    return {
      ...alteredFilter,
      includedUserTags: [
        ...(alteredFilter.includedUserTags || []),
        pivots.map((pivot) => pivot.name!)
      ]
    }
  }
})

export default pivotTagDecorator
